const MSG_CONFIRM_USER_CANCEL_INTENT = 'Are you sure that you want to cancel?'
const MSG_CONFIRM_USER_DONE_INTENT_GOLD = 'Click OK to complete your design and download the asset.'
const MSG_CONFIRM_USER_DONE_INTENT_SHOPIFY = 'Click OK to complete your design and add to cart. Cancel to go back and continue editing.'
const MSG_UPLOAD_FAILED = `An error occurred while uploading your image.
Please try again, or contact us if the problem persists.`

const MSG_UPLOADING_START = 'Processing...'
const MSG_UPLOAD_COMPLETE = 'Upload Finished.'

const MSG_ALERT_IMAGE_TOO_SMALL = (template) => {
  let padding = 300
  let width = template.production_size.w - padding
  let height = template.production_size.h - padding

  return `Sorry, that image is too small.
Please choose an image that is at least ${width}px wide and ${height}px tall.`
}

export {
  MSG_CONFIRM_USER_CANCEL_INTENT,
  MSG_CONFIRM_USER_DONE_INTENT_GOLD,
  MSG_CONFIRM_USER_DONE_INTENT_SHOPIFY,
  MSG_UPLOAD_FAILED,
  MSG_UPLOADING_START,
  MSG_UPLOAD_COMPLETE,
  MSG_ALERT_IMAGE_TOO_SMALL
}



// WEBPACK FOOTER //
// ./uncommon-client/language/index.js